import { useEffect } from "react";
import { useState } from "react";
import { Image } from "../models/post";
import ChangeImageModal from "../views/change-image-modal";
import Row from "../components/row";
import Divider from "../components/divider";
import { Wrapper } from "./post-components";
import styled from "styled-components";
import { DeleteButton } from "./text-component";
import { CloseRounded } from "@mui/icons-material";
import InfoStyle from "./info-style";

const ImageStyle = styled.div`
  position: relative;
  border-radius: 12px;
  width: 100%;
  border: 1px solid #EEEEEE;
  overflow: hidden;
  cursor: pointer;
  transition: .1s;
  &:hover {
    border-color: #c8c8c8;
  }
  img {
    width: 100%;
    object-fit: cover;
    vertical-align: middle;
  }
`;

export default function ImageComponent(props: {
  image: Image;
  update: (src: string, alt: string, info: string, link: string) => void;
  deleteContent: () => void;
}) {
  const { image, update } = props;
  const [src, setSrc] = useState(image.src);
  const [alt, setAlt] = useState(image.alt);
  const [info, setInfo] = useState(image.info);
  const [link, setLink] = useState(image.link);
  const [showDelete, setShowDelete] = useState(false);

  useEffect(() => {
    update(src, alt, info, link);
  }, [src, alt, info, update, link]);

  const [showModal, setShowModal] = useState(false);
  return <>
    <Divider />
    <ImageStyle onMouseMove={() => setShowDelete(true)} onMouseEnter={() => setShowDelete(true)} onMouseLeave={() => setShowDelete(false)} onClick={() => setShowModal(true)}>
      <img src={src} alt={alt} />
      <DeleteButton show={showDelete} onClick={props.deleteContent}>
        <CloseRounded />
      </DeleteButton>
    </ImageStyle>
    <Row>
      <Wrapper>
        <InfoStyle placeholder="Bildbeschreibung" value={alt} onChange={e => setAlt(e.target.value)} />
      </Wrapper>
      <Wrapper>
        <InfoStyle placeholder="Bildinformationen" value={info} onChange={e => setInfo(e.target.value)} />
      </Wrapper>
      <Wrapper>
        <InfoStyle placeholder="Link" value={link} onChange={e => setLink(e.target.value)} />
      </Wrapper>
    </Row>
    <Divider />
    {showModal && <ChangeImageModal
      close={() => setShowModal(false)}
      updateImage={(src: string) => {
        setSrc(src);
      }} />}
  </>;
}
